<template>
  <v-container class="select-metric" fluid justify-center fill-height>
    <page-title :title="$t('survey.select_metrics.page_title')"></page-title>
    <div>
      <h3>{{ $t('survey.select_metrics.title') }}</h3>
      <v-layout row wrap justify-center>
        <v-flex
          v-for="metric in metrics"
          :key="metric.type"
          class="metric"
          align-content-center
          justify-content
          xs3
        >
          <v-layout align-center justify-center column fill-height>
            <h2 class="metric-name">{{ metric.type }}</h2>
            <div class="metric-label">{{ metric.label }}</div>
            <div
              class="metric-status"
              :class="{ live: metric.live, paused: !metric.enabled }"
            >
              <label :class="{ paused: !metric.enabled }">{{ $t('no') }}</label>
              <v-switch
                v-model="metric.enabled"
                :readonly="metric.readonly"
                @click="change(metric)"
                class="lg-switch"
                :ripple="false"
              ></v-switch>
              <label :class="{ live: metric.enabled }">{{ $t('yes') }}</label>
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import filter from 'lodash/filter'
import find from 'lodash/find'
import each from 'lodash/each'
import EventBus from '@/event_bus'

export default {
  name: 'MetricSelection',
  props: {
    nps: Boolean,
    csat: Boolean,
    ces: Boolean
  },
  data: function() {
    return {
      metrics: [
        {
          type: 'NPS',
          label: 'Net Promoter Score',
          enabled: this.nps === undefined ? true : this.nps,
          readonly: false
        },
        {
          type: 'CSAT',
          label: 'Customer Satisfaction',
          enabled: this.csat === undefined ? true : this.csat,
          readonly: false
        },
        {
          type: 'CES',
          label: 'Customer Effort Score',
          enabled: this.ces === undefined ? true : this.ces,
          readonly: false
        }
      ]
    }
  },
  methods: {
    change: function(metric) {
      var vm = this
      const enabled = filter(this.metrics, function(d) {
        return d.enabled && d.type !== metric.type
      })
      if (enabled.length === 0) {
        metric.enabled = true
        metric.readonly = true
        EventBus.$emit('SHOW_SNACK', { msg: 'Atleast one metric is required' })
      } else {
        each(this.metrics, function(d) {
          d.readonly = false
        })
        setTimeout(function() {
          vm.$emit(
            'change',
            {
              metric: metric.type,
              enabled: metric.enabled
            },
            100
          )
        })
      }
    }
  }
}
</script>

<style lang="stylus">
.select-metric {
    padding 0

    h3 {
        text-align center
        margin-bottom 40px
        color: $color-primary-light-1
        font-weight: 500;
        font-size: 20px;
    }

    .metric {
        height 250px
        min-width 250px
        margin 25px
        border: 1px solid $color-primary-light-8;
        box-sizing: border-box;
        default-box-shadow()
        border-radius: 5px;
        text-align center
        padding 20px

        .metric-name {
            color: var(--v-primary-base)
            margin-bottom 12px
            font-size 18px
        }

        .metric-label {
            color: $color-primary-light-1
            margin-bottom 12px
            font-weight 500
            font-size 16px
        }

        .metric-status {
            display flex
            align-items center
            justify-content center
            font-weight 500
            position relative

            label {
                display none
                position absolute
                text-transform uppercase

                &.live {
                    display block
                    color: var(--v-accent-base)
                    left 60px
                }

                &.paused {
                    display block
                    color: $color-error
                    left: -20px
                }
            }

            .lg-switch {
                width 50px
                margin auto 5px
                height 47px

                .v-input--switch__track {
                    background-color $color-error
                }
            }
        }


    }
}
</style>
